<template>
    <div class="news">
      <el-col :span="24" :xs="24" :sm="24" :md="20" :lg="20" :xl="20" class="news-box">
            <el-col 
              v-for="(news_item, index) in news_list" :key="index" class="news-item-box">
              <!-- <div style="width: 100%; height: auto" > -->
                <el-col :span="6" class="newsitem-title-pic">
                  <el-image 
                    :src="news_item.pic_url"
                    fit="contain"></el-image>
                </el-col>
                <el-col :span="18" class="newsitem-title-box">
                  <el-row class="title-item p-t8">
                    <b>{{news_item.title}}</b>
                  </el-row>
                  <el-row class="title-item ">
                    {{news_item.sub_title}}</el-row>
                  <el-row class="title-item ">
                    {{news_item.time}}</el-row>
                  <el-row class="title-item-detail m-t8">
                    {{news_item.content}}</el-row>
                  <el-row class="title-item" v-if="news_item.url != ''">
                    <el-link type="primary" :href="news_item.url" target="_blank">原文链接</el-link>
                  </el-row>
                </el-col>
              <!-- </div> -->
            </el-col>

      </el-col>
    </div>
</template>
<script>
export default {
  name: "news",
  data() {
    return {
      news_list:[
        {title:'国家卫健委等四部门印发《医疗机构检查检验结果互认管理办法》 3月1日起施行',
        time:'2022-02-15 10:19',
        sub_title:'国卫医发〔2022〕6号',
        pic_url:require('./images/2022-6.png'),
        content:`各省、自治区、直辖市卫生健康委、中医药局、医保局，新疆生产建设兵团卫生健康委、医保局，军队各有关单位：
                为进一步提高医疗资源利用率，减轻人民群众就医负担，保障医疗质量和安全，我们制定了《医疗机构检查检验结果互认管理办法》，现印发给你们，请认真贯彻执行。   `,
        url:'http://www.nhc.gov.cn/yzygj/s7659/202202/b2ea61aed69746e195e79d4b505ee8b4.shtml'
        },{
          title:'国家卫生健康委办公厅关于加快推进检查检验结果互认工作的通知',
        time:'2021-07-16 ',
        sub_title:'国卫医发〔2020〕29号',
        pic_url:require('./images/2022-6.png'),
        content:`各省、自治区、直辖市及新疆生产建设兵团卫生健康委：
　　为深入贯彻国家卫生健康委等8部门联合印发的《关于进一步规范医疗行为促进合理医疗检查的指导意见》（国卫医发〔2020〕29号）要求，推进检查检验结果互认共享，提高医疗资源利用效率，改善人民群众就医体验.`,
        url:'http://www.nhc.gov.cn/yzygj/s7659/202107/0439d0f61888438385ee1b20c9de9fc5.shtml'
        },{
          title:'《关于印发进一步规范医疗行为促进合理医疗检查的指导意见的通知》 建立“云胶片”形式共享',
        time:'2020-12-31 10:19',
        sub_title:'国卫医发〔2020〕29号',
        pic_url:require('./images/2022-6.png'),
        content:`于2020年底印发了《关于进一步规范医疗行为促进合理医疗检查的指导意见》，要进一步规范医疗行为，促进合理检查。在机制创新层面，要求医疗机构通过建立检查资料数据库或“云胶片”等形式，推动检查资料共享。`,
        url:'http://www.nhc.gov.cn/yzygj/s2911/202012/32d1e29d565944ecb263c54bf8f19ec6.shtml'
      }]
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>
<style>
.news {
    background: var(--WhiteColor-1);
    height: 100%;
    margin-top: 8px;
    font-size: 14px;
    justify-content: center;
    display: flex;
  overflow: auto;
}
.news .news-box {
    /* width: 100%; */
    height: 100%;
  color: var(--BlackColor-1);
}
.news .news-box .news-item-box {
  display: flex;
  align-items: center;
  min-height: 33%;
  padding: 8px;
}
.news .news-box .news-item-box:hover {
  background: var(--SecondColor-10);
}
.news-item-box .newsitem-title-pic {
  overflow: hidden;
}
.news-item-box .newsitem-title-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 8px 16px;
  overflow: hidden;
  line-height: 140%;
  height: 100%;
}
.news-item-box .newsitem-title-box .title-item {
  white-space: nowrap;
  overflow: hidden;
  /* height: 20%; */
}
.news-item-box .newsitem-title-box .title-item-detail {
  /* height: 60%; */
  text-align:left;
  white-space: normal;
  text-overflow: ellipsis;
  overflow: hidden;
}

</style>